export enum LaunchModalMode {
  Add = 'add',
  Remove = 'remove'
}
